module.exports = __webpack_public_path__ + "img/Appointment.85db8ef6.png";